import PropTypes from 'prop-types'
import { useCallback, useEffect, useMemo, useState } from 'react'
import * as Portal from '@radix-ui/react-portal'
import ModalDialog from '../../Dialog/ModalDialog'
import ColorGroup from './ColorGroup'

const ColorExplorer = ({ activeIndex, setActiveIndex, groups }) => {
  const activeGroup = useMemo(
    () => (typeof activeIndex === 'number' ? groups[activeIndex] : null),
    [groups, activeIndex]
  )
  const [group, setGroup] = useState(activeGroup)

  useEffect(() => {
    // Might want to animate old one out before we do this
    if (!activeGroup) {
      // TODO: Why is this on a timeout?
      const timeout = setTimeout(() => setGroup(activeGroup), 1000)
      return () => clearTimeout(timeout)
    }
    setGroup(activeGroup)
  }, [activeGroup])

  const handlePressPrev = useCallback(
    () => setActiveIndex(currentIndex => Math.max(currentIndex - 1, 0)),
    []
  )

  const handlePressNext = useCallback(
    () =>
      setActiveIndex(currentIndex =>
        Math.min(currentIndex + 1, groups.length - 1)
      ),
    [groups.length]
  )

  return (
    <Portal.Root>
      <ModalDialog
        size='md'
        open={!!activeGroup}
        onClose={() => setActiveIndex(null)}
      >
        <ColorGroup
          num={activeIndex + 1}
          total={groups.length}
          group={group}
          onPressPrev={handlePressPrev}
          onPressNext={handlePressNext}
          nextDisabled={activeIndex >= groups.length - 1}
          prevDisabled={activeIndex <= 0}
        />
      </ModalDialog>
    </Portal.Root>
  )
}

ColorExplorer.propTypes = {
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func.isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default ColorExplorer
